'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConnectButton = exports.SYSTEM_ADMIN_OR_CONCUR_ADMIN_ROLE = exports.COMPANY_ADMIN_OR_WEB_SERVICE_ADMIN_ROLE = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _nuiIntl = require('@concur/nui-intl');

var _nuiWidgets = require('@concur/nui-widgets');

var _reactLoader = require('react-loader');

var _reactLoader2 = _interopRequireDefault(_reactLoader);

var _AutoConnectInput = require('./AutoConnectInput');

var _AutoConnectInput2 = _interopRequireDefault(_AutoConnectInput);

var _listingModule = require('./listingModule');

var _termsModule = require('../terms/termsModule');

var termsModule = _interopRequireWildcard(_termsModule);

var _AnalyticsModule = require('../analytics/modules/AnalyticsModule');

var analyticsModule = _interopRequireWildcard(_AnalyticsModule);

var _trackClick = require('../HOCs/trackClick');

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require('./style/listingDetails.css') : void 0;
!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require('./style/connectButton.css') : void 0;

var _analytics = require('../constants/analytics');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COMPANY_ADMIN_OR_WEB_SERVICE_ADMIN_ROLE = exports.COMPANY_ADMIN_OR_WEB_SERVICE_ADMIN_ROLE = 1;
var SYSTEM_ADMIN_OR_CONCUR_ADMIN_ROLE = exports.SYSTEM_ADMIN_OR_CONCUR_ADMIN_ROLE = 2;

var ConnectButton = function ConnectButton(_ref, _ref2) {
  var listing = _ref.listing,
      inquire = _ref.inquire,
      userId = _ref.userId,
      isDisabled = _ref.isDisabled,
      launchTaCModal = _ref.launchTaCModal,
      launchModal = _ref.launchModal,
      modalNames = _ref.modalNames,
      connectToListing = _ref.connectToListing,
      terms = _ref.terms,
      isConnecting = _ref.isConnecting,
      trackLinkClick = _ref.trackLinkClick,
      trackButtonClick = _ref.trackButtonClick,
      companyUUID = _ref.companyUUID,
      _ref$administration = _ref.administration,
      administration = _ref$administration === undefined ? {} : _ref$administration,
      trackInteractionEvent = _ref.trackInteractionEvent;
  var userProfile = _ref2.userProfile;
  var ID = listing.ID,
      _listing$core = listing.core,
      flow = _listing$core.oAuthWorkflowType,
      isUserConnected = _listing$core.isUserConnected,
      supportNewEnrollment = _listing$core.supportNewEnrollment,
      isConnectionPending = _listing$core.isConnectionPending,
      listingName = _listing$core.listingName,
      listingType = _listing$core.listingType,
      triplinkLoyaltyNumber = _listing$core.triplinkLoyaltyNumber,
      clientOptInType = _listing$core.clientOptInType,
      canUserConnect = _listing$core.canUserConnect,
      v1ID = _listing$core.v1ID,
      _listing$localized = listing.localized,
      connectURL = _listing$localized.connectURL,
      inquireURL = _listing$localized.inquireURL;


  var CON_REQ_FLOW = 'CONREQFLOW';
  var AUTO_CON_FLOW = 'AUTOCONFLOW';
  var ADMIN = 'ADMIN';

  var btnStyle = {
    width: '98%',
    minWidth: '150px',
    marginTop: '16px'
  };

  var spinnerOpts = {
    lines: 8,
    length: 0,
    width: 5,
    radius: 6,
    scale: 0.8,
    corners: 1,
    color: '#2379BF',
    opacity: 0.25,
    rotate: 0,
    direction: 1,
    speed: 1,
    trail: 60,
    fps: 20,
    zIndex: 2e9,
    className: 'spinner',
    shadow: false,
    top: '50%',
    left: '50%',
    position: 'relative',
    padding: '10px',
    hwaccel: false,
    height: '20px'
  };

  function isCompanyAdminOrWSAdmin() {
    var role = userProfile && userProfile.profile && userProfile.profile.Role;
    return role === COMPANY_ADMIN_OR_WEB_SERVICE_ADMIN_ROLE;
  }

  function isSystemAdminOrConcurAdmin() {
    var role = userProfile && userProfile.profile && userProfile.profile.Role;
    return role === SYSTEM_ADMIN_OR_CONCUR_ADMIN_ROLE;
  }

  function canConnectToEnterpriseApp() {
    return isCompanyAdminOrWSAdmin() || isSystemAdminOrConcurAdmin();
  }

  function trackClicked(element, additional) {
    return _react2.default.createElement(
      _trackClick.Tracked,
      {
        event: 'CLICK',
        additional: _extends(additional, {
          context: 'LISTING_DETAILS',
          v2_listing_id: ID,
          app_name: listingName,
          domain: window.location.hostname
        })
      },
      element
    );
  }

  function handleLaunchTaC(options) {
    trackButtonClick({
      elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.button.connect],
      dimensions: {
        listingId: ID,
        listingName: listingName,
        companyUUID: companyUUID
      }
    });
    launchTaCModal(_extends({
      tAndCLinkClicked: false,
      flow: flow,
      listingId: listing.ID,
      v1ListingId: v1ID,
      needAnAccountClicked: false
    }, options));
  }

  function connectBtn(btnDisabled) {
    var formatConnect = btnDisabled ? _react2.default.createElement(
      'span',
      { style: { fontStyle: 'italic' } },
      _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'Connect' })
    ) : _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'Connect' });

    return canUserConnect && trackClicked(_react2.default.createElement(
      'button',
      {
        id: 'listing-appcenter-flow-connect-button',
        className: 'btn btn-default btn-lg ' + (isDisabled ? 'disabled' : ''),
        onClick: handleLaunchTaC,
        style: btnStyle,
        disabled: btnDisabled || (flow === AUTO_CON_FLOW && !listing.loyaltyNumber || isConnecting) && !triplinkLoyaltyNumber
      },
      isConnecting ? _react2.default.createElement(_reactLoader2.default, {
        loaded: !isConnecting,
        options: spinnerOpts,
        className: 'connect-loader'
      }) : formatConnect
    ), { value: 'CONNECT', type: 'BUTTON' });
  }

  function disconnectBtn() {
    var launchDisconnectModal = function launchDisconnectModal() {
      trackButtonClick({
        elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.button.disconnect],
        dimensions: {
          listingId: ID,
          listingName: listingName,
          companyUUID: companyUUID
        }
      });
      launchModal(modalNames.disconnect);
    };

    // this removes the ability to disconnect from mobile
    if (connectURL && connectURL.indexOf('profile/profile_mobile.asp') !== -1) {
      return null;
    }

    return (clientOptInType === 'USER' || canConnectToEnterpriseApp()) && trackClicked(_react2.default.createElement(
      'button',
      {
        className: 'btn btn-lg btn-default',
        onClick: launchDisconnectModal,
        style: btnStyle
      },
      _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'Disconnect' })
    ), { value: 'DISCONNECT', type: 'BUTTON' });
  }

  function connectOrDisconnectBtn(btnDisabled) {
    return !isUserConnected ? connectBtn(btnDisabled) : disconnectBtn();
  }

  function handleInquireClicked(elementType) {
    trackInteractionEvent({
      elementType: elementType,
      elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.ReqInfo],
      dimensions: {
        listingId: ID,
        listingName: listingName,
        companyUUID: companyUUID
      }
    });
    window.open(inquireURL, 'Inquire');
    return inquire(listing.ID, userId);
  }

  var renderConnectedCheck = function renderConnectedCheck() {
    return userId && isUserConnected && _react2.default.createElement(
      'span',
      null,
      _react2.default.createElement('span', { className: 'is-connected-check-details icon-check icon-size-md' }),
      _react2.default.createElement(
        'h4',
        { className: 'connection-message' },
        listingType === 'ACONCT' ? _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'Enrolled' }) : _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'Connected' })
      )
    );
  };

  function requestInfoBtnAndDescription() {
    var deeplinkToListing = function deeplinkToListing() {
      window.location = _config2.default.CTEUrl + '?hpo=20&cte=' + listing.ID;
    };

    return _react2.default.createElement(
      'div',
      { style: { textAlign: 'left' } },
      !isUserConnected && _react2.default.createElement(
        'div',
        null,
        trackClicked(_react2.default.createElement(
          'button',
          {
            type: 'button',
            className: 'btn btn-lg btn-default',
            style: btnStyle,
            onClick: function onClick() {
              return handleInquireClicked(_analytics.elementList.button);
            }
          },
          _react2.default.createElement(
            'span',
            { style: { fontStyle: 'italic' } },
            _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'RequestInformation' })
          )
        ), { value: 'REQUEST_INFORMATION', type: 'BUTTON' }),
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null),
        _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'RequestInformationDescription' }),
        connectURL && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            _nuiWidgets.Button,
            {
              type: 'link',
              muted: userId && !canConnectToEnterpriseApp() || isDisabled,
              disabled: userId && !canConnectToEnterpriseApp() || isDisabled,
              style: { padding: '0px', textAlign: 'left' },
              onClick: function onClick() {
                if (userId) {
                  return handleLaunchTaC();
                }
                return deeplinkToListing();
              }
            },
            userId ? _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'Connect' }) : _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'LoginToConnect' })
          ),
          _react2.default.createElement('br', null),
          canConnectToEnterpriseApp() ? _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'ConnectBusinessApp' }) : _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'EndUserConnectBusinessApp' })
        )
      )
    );
  }

  function requestInfoLinkAndDescription() {
    return _react2.default.createElement(
      'div',
      { style: { textAlign: 'left', paddingTop: '16px' } },
      trackClicked(_react2.default.createElement(
        'a',
        { href: '#', onClick: function onClick() {
            return handleInquireClicked(_analytics.elementList.link);
          } },
        _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'RequestInformation' })
      ), { value: 'REQUEST_INFORMATION', type: 'LINK' }),
      _react2.default.createElement('br', null),
      _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'RequestInformationDescription' })
    );
  }

  function inquireBtn() {
    if (listingType === 'COCPAP') {
      if (canConnectToEnterpriseApp()) {
        return _react2.default.createElement(
          'div',
          { style: { textAlign: 'left' } },
          !isUserConnected && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h3',
              null,
              _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'ActivateBusinessApp' })
            ),
            _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'ConnectBusinessApp' })
          ),
          connectOrDisconnectBtn(),
          requestInfoLinkAndDescription()
        );
      }
      return _react2.default.createElement(
        'div',
        { style: { textAlign: 'left' } },
        connectOrDisconnectBtn(true),
        !isUserConnected && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement('br', null),
          _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'EndUserConnectBusinessApp' })
        ),
        requestInfoLinkAndDescription()
      );
    }
    return requestInfoBtnAndDescription();
  }

  function enrollBtn() {
    var launchEnrollModal = function launchEnrollModal() {
      trackButtonClick({
        elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.button.enroll],
        dimensions: {
          listingId: ID,
          listingName: listingName,
          companyUUID: companyUUID
        }
      });
      launchModal(modalNames.enroll);
      (0, _listingModule.checkForConnection)(ID, v1ID);
    };

    return trackClicked(_react2.default.createElement(
      'button',
      {
        type: 'button',
        className: 'btn btn-lg btn-default',
        style: btnStyle,
        onClick: launchEnrollModal,
        disabled: isConnecting
      },
      isConnecting ? _react2.default.createElement(_reactLoader2.default, {
        loaded: !isConnecting,
        options: spinnerOpts,
        className: 'connect-loader'
      }) : _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'Enroll' })
    ), { value: 'ENROLL', type: 'BUTTON' });
  }

  function unenrollBtn() {
    var launchUnenrollModal = function launchUnenrollModal() {
      trackButtonClick({
        elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.button.unenroll],
        dimensions: {
          listingId: ID,
          listingName: listingName,
          companyUUID: companyUUID
        }
      });
      launchModal(modalNames.unenroll);
      (0, _listingModule.checkForConnection)(ID, v1ID);
    };

    return trackClicked(_react2.default.createElement(
      'button',
      {
        type: 'button',
        className: 'btn btn-lg btn-default',
        style: btnStyle,
        onClick: launchUnenrollModal
      },
      _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'Unenroll' })
    ), { value: 'UNENROLL', type: 'BUTTON' });
  }

  function enrollOrUnenrollBtn() {
    return !isUserConnected ? enrollBtn() : unenrollBtn();
  }

  function loginToConnectBtn() {
    var deeplinkToListing = function deeplinkToListing() {
      window.location = _config2.default.CTEUrl + '?hpo=20&cte=' + listing.ID;
    };

    return _react2.default.createElement(
      'div',
      null,
      trackClicked(_react2.default.createElement(
        'button',
        {
          type: 'button',
          className: 'btn btn-lg btn-default',
          style: btnStyle,
          onClick: deeplinkToListing
        },
        _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'LoginToConnect' })
      ), { value: 'LOGIN_TO_CONNECT', type: 'BUTTON' }),
      inquireURL ? requestInfoLinkAndDescription() : null
    );
  }

  function showBtn() {
    if (userId) {
      if (isConnectionPending && !isUserConnected) {
        return;
      }

      if (clientOptInType === ADMIN) {
        return inquireBtn();
      }
      if (listingType === 'COCPAP') {
        return connectOrDisconnectBtn();
      }

      return enrollOrUnenrollBtn();
    }

    if (listingType === 'ADVISR') {
      return inquireBtn();
    }
    return loginToConnectBtn();
  }

  function showNeedAnAccountLink() {
    var launchTaC = function launchTaC(e) {
      trackLinkClick({
        elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.connectLoyaltyNumber, _analytics.needAnAccountLink, _analytics.launchTAndC],
        dimensions: {
          listingId: ID,
          listingName: listingName,
          companyUUID: companyUUID
        }
      });
      e.preventDefault();
      handleLaunchTaC({ needAnAccountClicked: true });
    };

    var connectWithoutTaC = function connectWithoutTaC(e) {
      trackLinkClick({
        elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.connectLoyaltyNumber, _analytics.needAnAccountLink, _analytics.connectWithoutTAndC],
        dimensions: {
          listingId: ID,
          listingName: listingName,
          companyUUID: companyUUID
        }
      });
      e.preventDefault();
      connectToListing(ID, v1ID, { needAnAccountClicked: true });
    };

    var areTermsAccepted = function areTermsAccepted() {
      if (terms) {
        return terms.previouslyAccepted || terms.currentlyAccepted;
      }
      return false;
    };

    if (isConnectionPending || isUserConnected) {
      return null;
    }

    return !isDisabled && userId && supportNewEnrollment && !triplinkLoyaltyNumber && clientOptInType !== ADMIN && _react2.default.createElement(
      'p',
      {
        style: { textAlign: 'center', paddingBottom: '5px' }
      },
      _react2.default.createElement(
        'a',
        {
          href: '#',
          onClick: areTermsAccepted() ? connectWithoutTaC : launchTaC
        },
        _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'NeedAnAccount' })
      )
    );
  }

  var renderAutoConnectInput = function renderAutoConnectInput() {
    return userId && (flow === AUTO_CON_FLOW || flow === CON_REQ_FLOW) && !isConnectionPending && !isUserConnected && _react2.default.createElement(_AutoConnectInput2.default, { listing: listing, isDisabled: isDisabled });
  };

  var showConnectionPendingMessage = function showConnectionPendingMessage() {
    return userId && (flow === AUTO_CON_FLOW || flow === CON_REQ_FLOW) && isConnectionPending && !isUserConnected && _react2.default.createElement(
      'div',
      { style: { textAlign: 'left' } },
      _react2.default.createElement(
        'h3',
        null,
        _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'ConnectionPending' })
      ),
      _react2.default.createElement('br', null),
      _react2.default.createElement(
        'h4',
        null,
        _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'ConnectionPendingMessage' })
      )
    );
  };

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      {
        className: userId && (flow === AUTO_CON_FLOW || flow === CON_REQ_FLOW || clientOptInType === ADMIN) ? 'loyalty-box' : '',
        style: { textAlign: 'center' }
      },
      false && _react2.default.createElement(
        'span',
        { style: { color: 'red', fontSize: '30px' } },
        userProfile.profile && userProfile.profile.LoginID
      ),
      renderAutoConnectInput(),
      renderConnectedCheck(),
      showNeedAnAccountLink(),
      showConnectionPendingMessage(),
      showBtn()
    )
  );
};

ConnectButton.propTypes = {
  listing: _propTypes2.default.shape({
    ID: _propTypes2.default.string,
    core: _propTypes2.default.object,
    images: _propTypes2.default.object,
    localized: _propTypes2.default.object,
    loyaltyNumber: _propTypes2.default.string,
    v1data: _propTypes2.default.object
  }).isRequired,
  modalNames: _propTypes2.default.shape({
    confirmation: _propTypes2.default.string,
    disconnect: _propTypes2.default.string,
    enroll: _propTypes2.default.string,
    unenroll: _propTypes2.default.string
  }).isRequired,
  terms: _propTypes2.default.shape({
    appcenterStatus: _propTypes2.default.object,
    isTaCModalOpen: _propTypes2.default.bool,
    appcenterTerms: _propTypes2.default.string,
    ereceiptTerms: _propTypes2.default.string,
    ereceiptStatus: _propTypes2.default.object,
    sharedInfoStatus: _propTypes2.default.object
  }).isRequired,
  userId: _propTypes2.default.string,
  connectToListing: _propTypes2.default.func.isRequired,
  checkForConnection: _propTypes2.default.func.isRequired,
  inquire: _propTypes2.default.func.isRequired,
  launchTaCModal: _propTypes2.default.func.isRequired,
  launchModal: _propTypes2.default.func.isRequired,
  isDisabled: _propTypes2.default.bool.isRequired,
  isConnecting: _propTypes2.default.bool.isRequired,
  trackLinkClick: _propTypes2.default.func,
  trackButtonClick: _propTypes2.default.func,
  trackInteractionEvent: _propTypes2.default.func,
  companyUUID: _propTypes2.default.string
};

ConnectButton.contextTypes = {
  userProfile: _propTypes2.default.object
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    isConnecting: state.listing.isConnecting,
    modalNames: state.listing.modalNames,
    userId: state.userPrefs.userId,
    terms: state.terms,
    companyUUID: state.userPrefs.companyUUID,
    userProfile: state.userProfile
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  launchModal: _listingModule.toggleModal,
  inquire: _listingModule.inquireListing,
  connectToListing: _listingModule.connectListing,
  launchTaCModal: termsModule.launchTaCModal,
  checkForConnection: _listingModule.checkForConnection,
  unenrollListing: _listingModule.unenrollListing,
  disconnectListing: _listingModule.disconnectListing,
  trackLinkClick: analyticsModule.linkClickDispatch,
  trackButtonClick: analyticsModule.buttonClickDispatch,
  trackInteractionEvent: analyticsModule.interactionEventDispatch
})(ConnectButton);
exports.ConnectButton = ConnectButton;


//////////////////
// WEBPACK FOOTER
// ./lib/listing/ConnectButton.js
// module id = 583
// module chunks = 0